export const CATEGORY_ICONS: { [key: string]: string } = {
	'Society & Action': `<svg width="22" height="19" viewBox="0 0 22 19" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.81522 1.29297C10.3926 0.292968 11.8359 0.292969 12.4133 1.29297L21.0736 16.293C21.6509 17.293 20.9292 18.543 19.7745 18.543H2.454C1.2993 18.543 0.577615 17.293 1.15497 16.293L9.81522 1.29297Z" fill="#FFD500"/>
</svg>`,
	'Future Care': `<svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="10.3514" cy="10.043" r="10" fill="#5846FF"/>
</svg>`,
	'Ecology & Action': `<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M17.3715 13.5886C17.9573 14.1744 17.9626 15.1341 17.3004 15.632C15.4648 17.0119 13.2199 17.7705 10.8967 17.7705C8.0704 17.7705 5.35982 16.6478 3.36131 14.6492C1.36279 12.6507 0.240031 9.94015 0.24003 7.11382C0.24003 4.79065 0.998605 2.5457 2.37859 0.710116C2.8764 0.0479446 3.83618 0.0532673 4.42196 0.639053L10.8967 7.11382L17.3715 13.5886Z" fill="#00FF80"/>
</svg>`,
	'Heritage in Motion': `<svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="0.588623" y="0.0429688" width="16" height="16" rx="3" fill="#FF4141"/>
</svg>`
};

export const PROFILE_CLOSE_BTN = `<svg
	class="profile-close-btn"
	width="30"
	height="30"
	viewBox="0 0 30 30"
	fill="none"
	xmlns="http://www.w3.org/2000/svg"
>
	<path
		d="M0.715698 0.859375L29 29.1436"
		stroke="white"
		stroke-width="1.5"
	/>
	<path
		d="M0.715698 29.1426L29 0.858307"
		stroke="white"
		stroke-width="1.5"
	/>
</svg>`;

export const PROGRAMME_TRANSLATIONS: { [key: string]: string } = {
	'Art & Design Management': 'Design és művészetmenedzsment',
	'Design Theory': 'Designelmélet',
	'Designer Maker': 'Tárgyalkotás',
	Design: 'Formatervezés',
	'Fashion & Textile Design': 'Divat- és textiltervezés',
	Interaction: 'Interaction',
	'Graphic Design': 'Tervezőgrafika',
	'Media Design': 'Média Design',
	Photography: 'Fotográfia',
	Architecture: 'Építőművészet',
	Animation: 'Animáció',
	'Design & Visual Art Teacher': 'Design- és vizuálisművészet-tanár'
};

export const SWIPE_THRESHOLD_PX = 138;
export const OFF_AXIS_RATIO = 0.5;
